import { useState, useEffect } from 'react';
import loadable from '@loadable/component';
const ClusterInnerMap = loadable(() => import('./ClusterInnerMap'), {ssr: false});

const ClusterMap = (props) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => setIsClient(true), []);

  if (!isClient) {
    return null;
  }

  return (
    <ClusterInnerMap {...props} />
  );
};

export default ClusterMap;